import {gql} from "@apollo/client";

// Node context required to assemble the createRiskAssessmentReport input:
// clientId (owner), regionKey (owner's region) and the node path. Only
// fetched for users who may create reports.
export const InstalledBaseNodeRiskReportContext = gql`
    query InstalledBaseNodeRiskReportContext($id: ID!) {
        installedBaseNode(id: $id) {
            id
            owner {
                id
                region {
                    id
                    key
                }
            }
            pathNodes {
                id
            }
        }
    }
`;
